import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLID,
  GraphQLInt,
  GraphQLList,
  GraphQLBoolean
} from 'graphql';

import { toGlobalId } from 'graphql-relay';

import PeerSubmissionReviewType from './peerSubmissionReview.gql';

const questionForReview = new GraphQLObjectType({
  name: 'QuestionForReview',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: (item) => {
        const offerId = item._id.toString();
        const rootOfferId = item.rootOfferId.toString();
        return toGlobalId('QuestionForReview', `${offerId}-${rootOfferId}`);
      }
    },
    pid: {
      type: GraphQLString,
      resolve: item => item._id.toString()
    },
    minReviewCount: {
      type: GraphQLInt,
      resolve: item => item.minReviewCount || 0
    },
    correspondingQuestionId: {
      type: GraphQLString,
      resolve: item => item.correspondingQuestionId
    },
    currentReviewCount: {
      type: GraphQLInt,
      resolve: (item) => {
        const card = item.states.find(i => i.contentId === item._id);
        const reviewsGivenCount = card && card.reviewsGivenCount;
        return reviewsGivenCount || 0;
      }
    },
    peerSubmissionsForReview: {
      type: new GraphQLList(PeerSubmissionReviewType),
      args: {
        fetchReviewed: {
          type: GraphQLBoolean
        }
      },
      resolve: item => [item]
    }
  })
});

window[questionForReview.name + 'GQLType'] = questionForReview;

export default questionForReview;
